<template>
  <div class="b_wrap" ref="b_wrap">
    <div class="b_content flex f_ai_c">
      <div class="cr_999 fs18 mr10">当前位置:</div>
      <div class="flex f_ai_c" v-for="(item, index) in list" :key="index">
        <div
          class="flex f_ai_c"
          :class="index + 1 == list.length ? 'cr_333' : 'cr_666'"
        >
          <!-- <img
            class="iconhome mr10"
            v-if="index == 0"
            src="@/assets/image/icon/public/home.svg"
            alt=""
          /> -->
          <!-- <img
            class="iconright mr10"
            v-else
            src="@/assets/image/icon/public/right.svg"
            alt=""
          /> -->
          <div
            class="fs18 mr10"
            :style="item.mcurl ? 'cursor:pointer' : ''"
            @click="go(item.mcurl)"
          >
            {{ item.dhmc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findMbx } from "@/http/api";
export default {
  props: {
    // 是否显示list中间的元素
    isshowcenter: {
      type: Boolean,
      default: true,
    },
    // 在点击url没有值时，是否返回，默认是返回上一级
    isgoback: {
      type: Boolean,
      default: true,
    },
    // 是否自定义数据
    iscustom: {
      type: Boolean,
      default: false,
    },
    // 自定义list，//用于没有接口等情况
    customList: {
      type: Array,
      default: () => [],
    },
  },

  mounted() {
    console.log(this.$route, "breadcrumb");
  },
  data() {
    return {
      list: [],
      mcurl: "",
    };
  },
  watch: {
    customList: {
      handler() {
        this.list = [...this.customList];
      },
      deep: true,
    },
    "$route.path": {
      handler() {
        this.mcurl = this.$route.path;
        this.findMbx();
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    async findMbx() {
      let { data } = await findMbx({ mcurl: this.mcurl });
      let list = [
        {
          dhmc: "首页",
          mcurl: "/home",
        },
      ];
      data?.forEach((item) => {
        if (!item) return;
        list.push(item);
      });

      this.list = list;
      if (this.list.length == 3) {
        if (!this.isshowcenter) {
          this.list.splice(1, 1);
        }
      }
    },

    go(url) {
      console.log(this.isgoback, "sdasdasd");
      if (this.isgoback) {
        if (!url) {
          this.$router.go(-1);
          return;
        }
      }

      this.$router.push({ path: url });
    },
  },
};
</script>
<style lang='scss' scoped>
.b_wrap {
  background-color: #fff;

  .b_content {
    @include main_area();
    padding: 20px 0;

    .iconhome {
      width: 24px;
      height: 24px;
    }

    .iconright {
      width: 14px;
      height: 20px;
    }
  }
}
</style>